// DashboardCard.js
import { Box } from '@mui/material';

export default function DashboardCard({ children }) {
  return (
    <Box
      className="main-container"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        flexWrap: 'nowrap',
        backgroundColor: '#ffffff',
        borderRadius: '20px',
        position: 'relative',
        overflow: 'hidden',
        height: { xs: 'auto', md: '352px' },
        padding: { xs: '16px', md: '24px' },
        marginBottom: { xs: '16px', md: '0px' },
        marginLeft: { sm: '0px', md: '10px' },
      }}
    >
      {children}
    </Box>
  );
}
